import {
  marketCountryIdFormat,
  marketIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { marketDefinitionWireFields } from "./market-definition";

export const marketOutput = z.object({
  id: marketIdFormat.schema,
  source: z.string(),
  shopCurrency: z.string(),
  name: z.string().nullable().optional(),
  enabled: z.boolean(),
  ...marketDefinitionWireFields,
  lastSyncedAt: z.date().nullable(),
});

export const marketCountryOutput = z.object({
  id: marketCountryIdFormat.schema,
  marketId: marketIdFormat.schema,
  destinationCountryCode: z.string(),
  sourceMarketId: z.string().nullable(),
  sourceCatalogId: z.string().nullable(),
  sourcePriceListId: z.string().nullable(),
  lastSyncedAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const marketWithCountriesOutput = z.object({
  market: marketOutput,
  countries: z.array(marketCountryOutput),
});
